import { Module } from "wrapper6";
import { objectFit } from "../utils/_object-fit";

export default class ObjectFit extends Module {
    ready() {
        objectFit();
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_object-fit.js